module.exports = __webpack_public_path__ + "img/greenDam.de9703b0.svg";